import React, { useEffect } from 'react'
import { Modal } from 'react-bootstrap'
import tiktok from '../../images/event/tiktok-winner.jpg'
import styled from 'styled-components'
import { LazyLoadImage } from 'react-lazy-load-image-component'
import Amplitude from 'src/utils/amplitudeHelper'

const StyledModal = styled(Modal)`
  .modal-body {
    padding: 0;
  }
`

export default function TikTokModal({ showModal, hideModal, currentUser }) {

  useEffect(() => {
    Amplitude.visit("TikTok")
  }, [currentUser.id])

  return (
    <StyledModal show={showModal} onHide={hideModal} size="xl" aria-labelledby="speakers-bio" centered>
      <Modal.Body>
        <LazyLoadImage effect="black-and-white" src={tiktok} width="100%" alt="tiktok winner" />
      </Modal.Body>
    </StyledModal>
  )
}
